<template>
  <popup v-model="isShow">
    <div class="keep-container">
      <img src="@/assets/keepstay-icon.png" alt="" srcset="">
      <div class="button-container">
        <button @click="leaveHandle">忍痛离开</button>
        <button class="active" @click="stayHandle">我再想想</button>
      </div>
    </div>
  </popup>
</template>

<script>
import { Popup } from 'mint-ui';
export default {
  name: 'Index',
  components: {
    Popup
  },
  data () {
    return {
      isShow: false
    }
  },
  methods: {
    show() {
      this.isShow = true
    },
    leaveHandle() {
      this.isShow = false
      this.$nextTick(() => {
        this.$emit('leave')
      })
    },
    stayHandle() {
      this.isShow = false
      this.$emit('stay')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.keep-container{
  width: 70vw;
  padding: 13px;
  border-radius: 8px;
  img{
    width: 100%;
  }
}
.button-container{
  display: flex;
  justify-content: space-around;
  button{
    border: solid 1px #03AF74;
    font-size: 16px;
    color: #03AF74;
    padding: 6px 16px;
    border-radius: 32px;
    outline: none;
    font-weight: 600;
    margin: 16px 0;
    background-color:transparent;
    &.active{
      background-color: #03AF74;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.mint-popup{
  border-radius: 12px;
}
</style>
